<template>
    <span v-if="mostrarBtnAtualizarValorHora" class="ml-2">
        <b-button
            variant="primary"
            @click.stop="abrirEntregaAtualizarValorHora()"
        >
            <span> <i class="fa fa-edit"></i> Atualizar Valor/Hora </span>
        </b-button>
        <b-modal
            id="modalEntregaAtualizarValorHora"
            v-model="mostrarModalEntregaAtualizarValorHora"
        >
            <div slot="modal-title">Entrega - Atualizar Valor/Hora</div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Valor/Hora atual</label>
                        <money
                            v-model="valorAtual"
                            v-bind="money"
                            class="form-control text-right"
                            :disabled="true"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.valorAtualizado.$error ? false : null"
                        invalid-feedback="Valor deve ser maior que 0"
                    >
                        <label>Valor/Hora atualizado</label>
                        <money
                            v-model="valorAtualizado"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="$v.valorAtualizado.$touch()"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharEntregaAtualizarValorHora()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarAtualizarValorHora()"
                    >Atualizar</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import { entregaStatus } from './EntregaStatus'

export default {
    props: {
        entrega: {
            type: Object,
            default: () => ({})
        },

        entregasServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModalEntregaAtualizarValorHora: false,
            erros: [],
            valorAtual: 0,
            valorAtualizado: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            }
        }
    },

    methods: {
        abrirEntregaAtualizarValorHora() {
            this.mostrarModalEntregaAtualizarValorHora = true
            this.valorAtual = this.entrega.valorHora
        },

        fecharEntregaAtualizarValorHora() {
            this.mostrarModalEntregaAtualizarValorHora = false
            this.resetEntregaAtualizarValorHora()
        },

        resetEntregaAtualizarValorHora() {
            this.valorAtual = 0
            this.valorAtualizado = 0
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        confirmarAtualizarValorHora() {
            this.$swal({
                title: 'Atualizar Valor/Hora',
                html: `Confirma a atualização do valor/hora da entrega?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.atualizarValorHora()
                }
            })
        },

        atualizarValorHora() {
            let valorHoraAtualizadoDto = {
                entregaId: this.entrega.entregaId,
                valorHoraAjustado: this.valorAtualizado
            }
            this.$store.dispatch('addRequest')
            this.entregasServicos
                .atualizarValorHora(valorHoraAtualizadoDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterEntregaAtualizada')
                            this.fecharEntregaAtualizarValorHora()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnAtualizarValorHora() {
            let retorno =
                (this.$temAcesso('CRED-UABS-ENTR-03') ||
                    this.$temAcesso('CRED-GEST-ENTR-04')) &&
                !this.entrega.temRegPagAprovado &&
                !this.entrega.status != entregaStatus.CANCELADA_SEM_PAGAMENTO &&
                !this.entrega.status != entregaStatus.CANCELADA_COM_PAGAMENTO
            return retorno
        }
    },

    validations: {
        valorAtualizado: {
            required,
            minValue: minValue(0.01)
        }
    }
}
</script>
